/* eslint-disable */
import axios from "axios";
import moment from 'moment';
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ChangeactivityStatusPopup from "../ChangeactivityStatusPopup/ChangeactivityStatusPopup.vue"
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue"
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
// import from 'jstree'
export default {
  components: {
    VPagination,
    ChangeSchedulestatus,
    CreateVideoCallSchedulePopUp,
    ChangeactivityStatusPopup
  },
  data() {
    return {
       FillForm: "FillForm",
      sProp: "",
      IsDesc: true,
      defaultdate: "",
      roleprivileges: "",
      baseapi: process.env.VUE_APP_Service_URL,
      localurl: process.env.VUE_APP_redirect,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      overduevisits: [],
      plannedvisits: [],
      sites: [],
      pageplannedindex: 1,
      pageplannedsize: 10,
      recentpageplannedsize: 10,
      currentplannedPage: 1,
      totalplannedCount: 0,
      totalrecentCount: 0,
      totalplannedPages: 0,
      pageoverdueindex: 1,
      pageoverduesize: 10,
      currentoverduePage: 1,
      totaloverdueCount: 0,
      totaloverduePages: 0,
      pageformindex: 1,
      pageformsize: 10,
      currentformPage: 1,
      totalformCount: 0,
      totalformPages: 0,
      patientLists: [],
      visitobj: {},
      formList: [],
      recentformList: [],
      currentRecentformPage: 1,
      totalformsPages: 0,
      recentpageformindex: 1,
      recentpageformsize: 10,
      SortProperty: "",
      SortOrder: 1,
      investigatorEmail: "",
      showSidePopup: [[[false]]],
      templateList: [],
      visitFormObj: {},
      observationValue:{},
      visitIdObj:{},
      selectedVisit: {},
      activityobject: {},
      activitystatusreload:{},
      selectedTemplate: "",
      sohowFormModal: false,
    showChangeActivity:false,
      sohowFormModalImminent:false,
      showChangeSchedule : false,
      showLoading:true,
      imminentShowLoading:true,
      recentShowLoading:true,
      formLoading:true,
      formlist: [],
      CreateVideoCallSchedulePopUp:false,
      selectedPatientId: null,
      statusType:"",
      changeStatus : {
        studyId : "",
        visitNo : "",
        subjectNo : "",
        visitstatus : ""
      },
      visitIndex :"",
      showObservationsLoading:{},
      categoryFlags:{},
      studyRef:{},
      selectedForm:"",
      studyInfo:"",
      selectedVisitName:"",
      formIndex:"",
      scheduleId:"",
      openedformsarray:[],
      openedpatientarray:[],
      openedvisitsarray:[],
      openedsitesarray:[],

    };
  },

  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.getstudyinfo()
      this.getoverduevisits();
      this.getplannedvisits();
      this.getsites();
      this.getForms();
      this.GetRecentFormData();
    });
    await this.setroleprivileges();
    this.investigatorEmail = jwt_decode(store.getters.getIdToken)
    await this.getstudyinfo()
    this.getoverduevisits();
    this.getplannedvisits();
    await this.getsites();
    this.getForms();
    this.GetRecentFormData();
    this.restoreopenedtree();
  },
  unmounted(){
    store.dispatch("setopentreeforsubmitForm", false);
  },
  methods: {
    showPopover(id) {
      document.getElementById(id)?.showPopover?.();
    },
    hidePopover(id) {
      document.getElementById(id)?.hidePopover?.();
    },
    async restoreopenedtree(){
      const iftreeopened = store.getters.getopentreeforsubmitForm;
      console.log("iftreeopened",iftreeopened);
      if(iftreeopened){
      await this.restoresites();
      await this.restorpatients();
      await this.restoreforms();
      }
      
    },
    async restoresites(){
        let openedsitesarray = store.getters.getopenedsitesarray;
              console.log("openedsitesarray",openedsitesarray);
              await openedsitesarray.forEach(async (eachsites)=>{
                  document.getElementById(eachsites.siteId).click();
              });
    },
    async restorpatients(){
          let openedpatientsarray = store.getters.getopenedpatientarray;
          await openedpatientsarray.forEach(async (eachpatients)=>{
                  console.log("eachpatients",eachpatients);
                  if(!this.visitobj[eachpatients.patientId]){
                  this.visitobj[eachpatients.patientId]=[];
                  };
                  await this.getVisits(eachpatients.patientId, eachpatients.index);
                  let cb = document.getElementById(eachpatients.patientId);
                  if (cb) {
                      cb.checked = true;
                  }
                });
    },
    findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder) {
      const key = `${visitNo}_${subjectId}`;
      const arr = (this.activityobject[key]?.[visitIndex]?.data) || [];
      return arr.findIndex(a => a.activityId === activityid && a.activityOrder === activityorder);
    },
    async restoreforms(){
          let openedformsarray = store.getters.getopenedformsarray;
           for (const eachform of openedformsarray) {
                const { subjectId, visitNo, visitIndex: vIndex, sheduleId } = eachform;
                const visitCheckboxId = sheduleId + subjectId;

                // (a) Wait until <input id="visitNo+subjectId"> exists
                await this.waitForElement(`#${CSS.escape(visitCheckboxId)}`);

                // (b) Call the same logic your @change would call:
                await this.getFormsByVisit(subjectId, visitNo, eachform.visitName, vIndex, sheduleId);
                document.getElementById(visitCheckboxId).checked = true;
                
                await this.$nextTick();
    }
    },
    waitForElement(selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const start = performance.now();
      const check = () => {
        if (document.querySelector(selector)) {
          resolve();
        } else if (performance.now() - start > timeout) {
          reject(new Error(`Element ${selector} not found within ${timeout}ms`));
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async openFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModal = true;
    },
    async openImminentFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModalImminent = true;
    },
    async closeFormsModal() {
      this.sohowFormModal = false;
    },
    async closeImminentFormsModal() {
      this.sohowFormModalImminent = false;
    },
    openVideoCallSchedulePopup(patientId) {
      this.selectedPatientId = patientId; // Set the selected patient ID
      console.log("Patient id is",this.selectedPatientId);
      this.CreateVideoCallSchedulePopUp = true; // Open the popup
    },
    // async viewForm(formId, isPatientVisit) {
    //   this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    // },
    async listvisitForms(visitNo, patientId, studyId) {
      const idtoken = store.getters.getIdToken;
      await
        axios.get(`${this.baseUrl}getfromsbyvisit?studyId=${studyId}&patientID=${patientId}&visitNo=${visitNo}`, {          
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((res) => {
          console.log("Visit form list is...", res);
          this.formlist = res.data.data;
        })
          .catch(err => console.log(" error in getting visit forms...", err));
    },
    async gotoform(singlevisit, autosubjectid, autositecode, visitNo,patientId  ) {
      if(singlevisit.visitStatus == 'Withdrawn'){
        alert("The form has already been withdrawn.");
      }
      else{
      await store.dispatch("setautofillsiteid", autositecode);
      await store.dispatch("setautofillsubjectid", autosubjectid);
      await store.dispatch("setautofillenabled", "true");
      let tempvar = {
          "Siteid": singlevisit.siteId,
          "Study_Id":singlevisit.studyId,
          "Subject_id": singlevisit.patientId,
          "Visitname": singlevisit.visitName,
          "Visitno": singlevisit.visitNo,
          "sheduleId": singlevisit.sheduleId
        }
        await store.dispatch("commitvisitdetails", tempvar);
      if (singlevisit.formId == null || singlevisit.formId == "") {
        
        if (singlevisit.templateId == null || singlevisit.templateId == "") {
          alert(this.$t("navigations.no template assigned"))
        }
        else {
          this.$router.push(`/form/${singlevisit.isPatientVisit}/${singlevisit.templateId}/${singlevisit.studyId}/${this.visitIdObj[visitNo+patientId]}?${this.visitIdObj[visitNo+patientId]}:0`);
        }

        // this.$router.push(`/form/${visits.templateId}/${visits.studyId}/${visits.visitid}`);
      }

      else {
        this.$router.push(`/editForm/submitForm/${singlevisit.formId}/${singlevisit.isPatientVisit} `);
      }
    }
    },
    async gotofillform(visits, autosubjectid, autositecode) {
      if (!this.selectedTemplate) {
        alert("Please select a form.");
        return;
      }
      console.log("gotofillform visits", visits);
      await store.dispatch("setautofillsiteid", autositecode);
      await store.dispatch("setautofillsubjectid", autosubjectid);
      await store.dispatch("setautofillenabled", "true");
      const template = this.templateList.find(t => t.templateId === this.selectedTemplate);
      let tempvar = {
        "Siteid": visits.siteId,
        "Subject_id": visits.patientId,
        "Visitname": visits.visitName,
        "Visitno": visits.visitNo,
        "sheduleId": visits.sheduleId,
        "Template_name": template.templateName
      }
      await store.dispatch("commitvisitdetails", tempvar);
      await store.dispatch("setfrompatientschedule", 'frompatientschedule');
      this.$router.push({
        path: `/form/${visits.isPatientVisit}/${this.selectedTemplate}/${visits.studyId}/${this.visitIdObj[visits.visitNo+visits.patientId]}?${this.visitIdObj[visits.visitNo+visits.patientId]}:0`,
        query: {
          tempObj: encodeURIComponent(JSON.stringify(tempvar))
        }
      });

    },
    async goToForms() {
      if (visits.formId == null || visits.formId == "") {
        this.gotoform();
      }
      else {
        this.EditForm();
      }
    },
    async EditForm(formId, isPatientVisit) {
      this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    },
    async goTovisitTemplate(lists,patientId) {
      if(lists[0].visitStatus == 'Withdrawn'){
        alert("The form has already been withdrawn.");
      }
      else{
      localStorage.setItem("patid",patientId)
      await store.dispatch("setautofillsiteid", lists[0].siteCode);
      await store.dispatch("setautofillsubjectid", lists[0].patientNo);
      await store.dispatch("setautofillenabled", "true");
      if (await lists[0].templateId != null && await lists[0].templateId != "null" && await lists[0].formId == null || await lists[0].formId == "null") {
        let tempvar = {
          "Siteid": lists[0].siteId,
          "Subject_id": lists[0].patientId,
          "Study_Id":lists[0].studyId,
          "Visitname": lists[0].visitName,
          "Visitno": lists[0].visitNo,
          "sheduleId": lists[0].sheduleId
        }

        await store.dispatch("commitvisitdetails", tempvar);
        this.$router.push(`/form/${lists[0].isPatientVisit}/${lists[0].templateId}/${lists[0].studyId}/0 `);
      }
      else if (await lists[0].templateId != null && await lists[0].templateId != "null" && await lists[0].formId != null && await lists[0].formId != "null") {
        let tempvar = {
          "Siteid": lists[0].siteId,
          "Subject_id": lists[0].patientId,
          "Study_Id":lists[0].studyId,
          "Visitname": lists[0].visitName,
          "Visitno": lists[0].visitNo,
          "sheduleId": lists[0].sheduleId
        }

        await store.dispatch("commitvisitdetails", tempvar);
        this.$router.push(`/editForm/submitForm/${lists[0].formId}/${lists[0].isPatientVisit} `);
      }

      else if (await lists[0].templateId == null || await lists[0].templateId == "null") {
        alert(this.$t("navigations.no template assigned"))
      }
    }
    },
    async goToTemplate(isPatientVisit,templateid,visitid){
      await store.dispatch("setautofillsiteid", "");
      await store.dispatch("setautofillsubjectid", "");
      await store.dispatch("setautofillenabled", "false");
      const studyid = store.getters.getStudyIs;
      this.$router.push(`/form/${isPatientVisit}/${templateid}/${studyid}/${visitid}`);
    },
    async isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async viewform(id, siteid, subid,patid,studyid) {
      console.log("siteid, subid = ", siteid, subid);
      if(siteid != null || subid != null){
        console.log("siteid, subid = ", siteid, subid);
        await store.dispatch("setautofillenabled", "true");
      }
      else{
        await store.dispatch("setautofillenabled", "false");
      }
      let tempvar = {
          "Siteid": "",
          "Subject_id":patid,
          "Study_Id":studyid,
        }

        await store.dispatch("commitvisitdetails", tempvar);
      this.$router.push(`/editForm/submitForm/${id}/0`);
    },
    async setFontSize(el) {
      var fontSize = el.val();

      if (isNumber(fontSize) && fontSize >= 0.5) {
        $('body').css({ fontSize: fontSize + 'em' });
      } else if (fontSize) {
        el.val('1');
        $('body').css({ fontSize: '1em' });
      }
    },
    async itemClick(node) {
      console.log(node.model.text + ' clicked !')
    },

    filter(data) {
      if (data) {
        return moment(data).utc().format(this.defaultdate);
      }
      console.log(data);
    },
    filterMonth(date) {
      if (date) {
        //console.log("dateeeeeeeeee",date)
        return moment(date).format('DD-MMM-YYYY')
      }
    },
    SortSelectforms(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.GetRecentFormData();
    },
    async GetRecentFormData() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      this.recentShowLoading=true
      await axios
        .get(`${this.baseapi}/forms/ecrfsource/getpaginatedrecentecrf?studyId=${stdid}&userEmail=${this.investigatorEmail.email}&pageindex=${this.recentpageformindex}&pagesize=${this.recentpageformsize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`, 
          {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.recentformList = response.data.results          
            this.totalrecentCount = response.data.totalCount;

            this.totalformsPages = parseInt(this.totalrecentCount / this.recentpageplannedsize);
            if (this.totalrecentCount % this.recentpageplannedsize != 0) {
              this.totalformsPages = this.totalformsPages + 1;
            }


            this.recentShowLoading=false
          }
          else {
            this.recentShowLoading=false
          }
        })

        .catch((err) => {
           this.recentShowLoading=false
          console.log(err);
        });
    },
    SortSelected(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getoverduevisits();
    },
    async getoverduevisits() {
       this.showLoading=true
      this.overduevisits = []
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudyid}&VisitStatus=Overdue&PageNo=${this.pageoverdueindex}&ItemCount=${this.pageoverduesize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.overduevisits = res.data.data;
          console.log("Overdue visits are", this.overduevisits)
          this.totaloverdueCount = res.data.totalCount;
          this.totaloverduePages = parseInt(res.data.totalCount / this.pageoverduesize);
          if (this.totaloverdueCount % this.pageoverduesize != 0) {
            this.totaloverduePages = this.totaloverduePages + 1;
          }
          this.showLoading=false
        })
        .catch((err) => {
           this.showLoading=false
          console.log(err);
        });
    },
    SortSelect(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getplannedvisits();
    },
    async getplannedvisits() {
      this.plannedvisits = []
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
       this.imminentShowLoading=true
      await axios
        .get(`${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudy}&VisitStatus=Imminent&PageNo=${this.pageplannedindex}&ItemCount=${this.pageplannedsize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.plannedvisits = res.data.data;
          this.totalplannedCount = res.data.totalCount;
          this.totalplannedPages = parseInt(res.data.totalCount / this.pageplannedsize);
          if (this.totalplannedCount % this.pageplannedsize != 0) {
            this.totalplannedPages = this.totalplannedPages + 1;
          }
          this.imminentShowLoading=false
        })
        .catch((err) => {
          this.imminentShowLoading=false
        });
    },
    async getsites() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudyid}&getAll=false&sortProperty=siteCode&IsDes=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.sites = res.data;
          console.log("Sites are", this.sites)
          console.log("Current study is", currentstudyid)
          console.log(idtoken)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getpatient(siteId, index) {
      let newopenedpatent = {
        "siteId":siteId,
        "index":index
      }
       const existingIndex = this.openedsitesarray.findIndex(
    item => item.siteId === siteId && item.index === index
  );

        if (existingIndex !== -1) {
          this.openedsitesarray.splice(existingIndex, 1);
        }
      else{
      this.openedsitesarray.push(newopenedpatent);
    }
      await store.dispatch("setopenedsitesarray", this.openedsitesarray);
      this.patientLists[index] = [];
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/management/patient/listpatient?SiteId=${siteId}&Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          let data = res.data.results;
          await data.forEach(patientdata => {
            this.visitobj[patientdata.patientId] = [];
          });
          this.patientLists[index] = data;
          console.log("patient list is", this.visitobj)
        });
      // await this.setvisitobj(this.patientLists[index]);
    },
    async setvisitobj(data) {
      console.log("set visit function");
      console.log("patient list is", data);
      data.forEach(patientdata => {
        this.visitobj[patientdata.patientId] = [];
      });
      console.log(this.visitobj);
    },
    async getVisits(patientId, index) {
      console.log("patientId, index",patientId, index);
      let openedvisit = {
            "patientId":patientId,
            "index":index
          }
          const existingIndex = this.openedpatientarray.findIndex(
        item => item.patientId === patientId && item.index === index
      );

      if (existingIndex !== -1) {
        // It’s already in the array → remove it
        this.openedpatientarray.splice(existingIndex, 1);
      } else {
          this.openedpatientarray.push(openedvisit);
      }
      await store.dispatch("setopenedpatientarray", this.openedpatientarray);
      this.visitobj[patientId][index] = [];
      const idtoken = store.getters.getIdToken;
      console.log("patient ID is", patientId)

      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.visitobj[patientId][index] = res.data.data;
          console.log("The visit list is", this.visitobj)
        })
        .catch((err) => {
          console.log("error is", err);
        })
      this.displayTable = true
    },
    // async getForms()
    // { 
    //   const idtoken = store.getters.getIdToken;
    //   const currentstudyid = store.getters.getStudyIs;
    //   await axios
    //   .get(
    //     `${this.baseapi}/management/visit/listvisit?StudyId=${currentstudyid}&pageindex=${this.pageformindex}&pagesize=${this.pageformsize}`,
    //     {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    //   .then((res) => {
    //       this.formList = res.data.results;
    //       console.log("The form list is",this.formList)
    //       this.totalformCount = res.data.totalCount;
    //       this.totalformPages=parseInt(this.totalformCount / this.pageformsize)
    //        if((this.totalformCount % this.pageformsize) !=0){
    //         this.totalformPages = this.totalformPages+1
    //       }
    //   })
    //   .catch((err) =>{
    //       console.log("error is" , err);
    //   })
    //   this.displayTable=true
    // },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.getForms();
    },
    async getForms() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      this.formLoading=true
     const head = {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
      axios.get(`${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&StudyID=${currentstudyid}&Status=Approved&pageindex=${this.currentTemplatePage}&pagesize=5&SortProperty=templateName&SortOrder=0`, head)
      
        .then((res) => {
          console.log("template details ", res.data);
          this.formList = res.data.results;

          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / 5);
          if (totalCount % 5 != 0) {
            this.totalTemplatePages = this.totalTemplatePages + 1;
          }
          this.formLoading=false
        })
        .catch(err => this.formLoading=false);
    },
    async listTemplate(){
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${currentstudyid}&&SortProperty=templateName&SortOrder=0 `,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        console.log("Study template list is...", res.data);
        this.templateList = res.data.results;
      })
        .catch(err => console.log("error while getting template list", err))
    },
    toggleSidePopup(sIndex, pIndex, vIndex) {
      console.log("Toggle", sIndex, this.showSidePopup);

      // Initialize arrays if they don't exist
      if (!this.showSidePopup[sIndex]) {
        this.showSidePopup[sIndex] = [];
      }
      if (!this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex] = [];
      }

      // Toggle the value
      if (typeof this.showSidePopup[sIndex][pIndex][vIndex] === 'undefined') {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
      this.showSidePopup[sIndex][pIndex][vIndex] = !this.showSidePopup[sIndex][pIndex][vIndex];
    }
    ,
    closeSidePopup(sIndex, pIndex, vIndex) {
      if (this.showSidePopup[sIndex] && this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
    },
    async openModal(visit, subjectId, siteCode, visitNo,patientId) {
      if(visit.withdrawnDate){
        alert("You cannot add new forms to a withdrawn visit");
      }
      else{
      console.log("Open Modal", visit, subjectId, siteCode)
      this.selectedVisit.visit = visit;
      this.selectedVisit.subjectId = subjectId;
      this.selectedVisit.siteCode = siteCode;
      console.log("selected visit is ", this.selectedVisit);
      // this.selectedmodeltemplate = "";
      // this.selectedvisitid = visitid;
      await this.listTemplate();
      const modalWrapper = document.querySelector(".modal-wrapper");
      modalWrapper.classList.add("active");
      }
    },
    
    closeModal() {
      // this.selectedmodeltemplate = "";
      const modalWrapper = document.querySelector(".modal-wrapper");
      modalWrapper.classList.remove("active");
    },
    async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
          await axios
        .get(
          `${this.baseapi}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
          this.studyRef = res.data.studyRef
        })
        .catch((err) => {
          console.log(err);
        });
    },
       async getFormsByVisit(
        subjectId,
        visitNo,
        visitName,
        visitIndex,
        sheduleId,
        activityindex,
        activityid,
        activityorder
      ) {
        // (unchanged) toggle checkbox safely
        if (activityid != null && activityorder != null) {
          const cbId = `${activityid}${subjectId}${visitNo}${activityorder}`;
          const el = document.getElementById(cbId);
          if (el) el.checked = !el.checked;
        }

        // (unchanged) persist open state
        const opened = { sheduleId, subjectId, visitNo, visitName, visitIndex };
        if (activityid != null && activityorder != null) {
          opened.activityid = activityid;
          opened.activityorder = activityorder;
        }
        const existingIndex = this.openedformsarray.findIndex(item =>
          item.sheduleId === sheduleId &&
          item.subjectId === subjectId &&
          item.visitNo === visitNo &&
          item.visitName === visitName &&
          item.visitIndex === visitIndex &&
          (
            (opened.activityid == null && item.activityid == null) ||
            (opened.activityid != null &&
            item.activityid === opened.activityid &&
            item.activityorder === opened.activityorder)
          )
        );
        if (existingIndex !== -1) this.openedformsarray.splice(existingIndex, 1);
        else this.openedformsarray.push(opened);
        await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);

        // (unchanged) data prep
        const key = visitNo + subjectId;
        if (!this.visitFormObj[key]) this.visitFormObj[key] = [];
     
        if (activityindex == null && activityid != null) {
          activityindex = this.findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder);
          if (activityindex < 0) activityindex = 0;
        }
        if (activityindex == null) activityindex = 0;
        this.visitFormObj[key][activityindex] = [];

        // --- CHANGED PART: build request without `??` and without manual string concat
        const idtoken = store.getters.getIdToken;
        const stdid = store.getters.getStudyIs;

        try {
          const res = await axios.get(
            `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
              params: {
                studyId: stdid,
                patientID: subjectId,
                visitNo: visitNo,
                visitName: visitName,
                activityId: activityid == null ? "" : activityid,
                activityOrder: activityorder == null ? "" : activityorder,
              },
            }
          );
          this.visitFormObj[key][activityindex] = res.data.data;
        } catch (err) {
          console.log("error while getting visit forms list", err);
        }
      },
    async getactivities(subjectId, visitNo, visitName, visitIndex, sheduleId, siteCode, patientNo) {
      const visitKey = `${visitNo}_${subjectId}`;
      const openedforms = { sheduleId, subjectId, visitNo, visitName, visitIndex };

      const existingIndex = this.openedformsarray.findIndex(
        item => item.sheduleId === sheduleId && item.subjectId === subjectId &&
          item.visitNo === visitNo && item.visitName === visitName &&
          item.visitIndex === visitIndex
      );

      if (existingIndex !== -1) {
        this.openedformsarray.splice(existingIndex, 1);
      } else {
        this.openedformsarray.push(openedforms);
      }

      await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);
      this.visitIndex = visitIndex;

      if (!this.activityobject[visitKey]) {
        this.activityobject[visitKey] = [];
      }

      this.observationValue[visitKey] = false;
      this.activityobject[visitKey][visitIndex] = [];

      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getactivitynames?subjectId=${subjectId}&visitNo=${visitNo}&studyId=${currentstudyid}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.activityobject[visitKey][visitIndex] = res.data.data;
        this.getVisitId(visitNo,subjectId);
        this.toggleObservationFolder(siteCode, patientNo, visitName, visitNo, subjectId);
      } catch (err) {
        console.error("Error while getting visit forms list", err);
      }
    },
     async getVisitId(visitNo,subjectId) {
      this.visitIdObj[visitNo+subjectId]=""
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/management/visit/listvisit?VisitNo=${visitNo}&studyId=${stdid}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        this.visitIdObj[visitNo+subjectId]= res.data.results[0].visitId;
      })
        .catch(err => console.log("error while getting visit forms list", err)

        )
    },
    async listVisitForms(siteId, subjectId, visitNo) {
      this.visitFormObj[visitNo] = [];
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/forms/forms/getformsbyids?studyid=${stdid}&siteid=${siteId}&subjectid=${subjectId}&visitno=${visitNo}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        this.visitFormObj[visitNo] = res.data;
        console.log("Visit form list is...", this.visitFormObj);
        console.log("data is ", this.visitFormObj[visitNo])
      })
        .catch(err => console.log("error while getting visit forms list", err)

        )
    },
    selectDocument(siteCode,patientId,doc,visitName,subjectId,siteId){
      sessionStorage.setItem('FHIRpatient', JSON.stringify(doc));
      this.$router.push(`/FHIRpage/${siteCode}/${patientId}/${visitName}/${subjectId}/${siteId}`)
    },
    filterTimeFormat(data) {
      if(data){
        return data.replace(/:00\+00:00$/, ''); 
      }     
    },
    async toggleObservationFolder(siteCode,subjectCode,visitCode,visitNo,patientId){ 
      await axios
      .get(
        `${this.baseapi}/fhir-service/fhir/observations?StudyRef=${this.studyRef}&SiteCode=${siteCode}&Subjects=${subjectCode}&VisitCodes=${visitCode}`,
     
      ).then((res) => {
        if(res.data && res.data.length!=0 && res.data!='Visits Not Found'){
          this.observationValue[visitNo+patientId]=true
          this.categoryFlags[visitNo + patientId] = Object.values(
          res.data.reduce((acc, doc) => {
            const document = doc.resource;
            const id=doc.resource.id
            const category = doc.resource.category[0].coding[0].display;
            const codeText = doc.resource.code.text ?  doc.resource.code.text : doc.resource.code.coding[0].display; // Handle missing `text`
            const effectiveDateTime = doc.resource.effectiveDateTime || null;
        
            // If the category already exists, add the code to its array
            if (!acc[category]) {
              acc[category] = {
                category: category,
                code: [],
                effectiveDateTime: [],
                flag: false,
                document: [],
                id: [],
                idSet: new Set(), // Track unique IDs
              };
            }   // Push codeText to the array (allowing duplicates)
            if (id && !acc[category].idSet.has(id)) {
                acc[category].idSet.add(id);
                acc[category].id.push(id);

              if (codeText) {
                acc[category].code.push(codeText);
              }
              if (effectiveDateTime) {
                acc[category].effectiveDateTime.push(effectiveDateTime);
              }
              if (document) {
                acc[category].document.push(document);
              }
            }
        
            return acc;
            
          }, {})     
       
     
        );
        const vitalSignsCategory = this.categoryFlags[siteCode + subjectCode].find(category => category.category === "Vital Signs" || category.category === "vital signs"
        )
        let latestVitalSigns = [];

        if (vitalSignsCategory) {
          const { code, document, unit, effectiveDateTime } = vitalSignsCategory;

          // Combine code and effectiveDateTime into a single array of objects
          const combined = code.map((c, index) => ({
            code: c,   
            value:  c == 'Blood Pressure' ? `${document[index].component[1].valueQuantity.value}/${document[index].component[2].valueQuantity.value}` : 
            c == 'Body height' || c == 'Body weight' ||  c == 'Body Temperature' ? document[index].valueQuantity.value : '',
            unit: c == 'Blood Pressure' ? document[index].component[1].valueQuantity.unit: c == 'Body height' || c == 'Body weight' ||  c == 'Body Temperature' ? document[index].valueQuantity.unit : '',  
            effectiveDateTime: effectiveDateTime[index] // Convert to Date for sorting
          }));
          // Sort by effectiveDateTime in descending order
          combined.sort((a, b) => b.effectiveDateTime - a.effectiveDateTime);

          // Extract the latest unique code entries
          const seenCodes = new Set();
          const latestVitalSigns = combined.filter(entry => {
            if (!seenCodes.has(entry.code)) {
              seenCodes.add(entry.code);
              return true;
            }
            return false;
          }).map(entry => ({
            code: entry.code,
            value: entry.value,
            unit:entry.unit,
            effectiveDateTime: entry.effectiveDateTime // Convert back to string if needed
          }));
          this.vitalSignsList=latestVitalSigns
        }
        }
        else{
          console.log("entered-2")
            this.observationValue[visitNo+patientId]=false
        }
        

      })
      .catch((err)=>{
        console.log("Error",err)
      })
    },
    async closePopover(id) {
      document.getElementById(id)?document.getElementById(id).hidePopover():null
    },
     async openChangeStatusmodalforactivity(
      actScheduleId,
      status,
      patientId,
      visitNo,
      visitName,
      vIndex,
      sheduleId,
      popoverId
    ) {
      await this.closePopover(popoverId);
      this.activitystatusreload.patientId = patientId;
      this.activitystatusreload.visitNo = visitNo;
      this.activitystatusreload.visitName = visitName;
      this.activitystatusreload.sheduleId = sheduleId;
      this.activitystatusreload.vIndex = vIndex;
      this.selectedActivityid = actScheduleId;
      this.currentactivitystatus = status;
      this.showChangeActivity = true;
    },
    async closeChangeactivityModal() {
      this.showChangeActivity = false;
    },
    async changedactivityStatus(activitystatusreload){
      this.getactivities(
                                activitystatusreload.patientId,
                                activitystatusreload.visitNo,
                                activitystatusreload.visitName,
                                activitystatusreload.vIndex,
                                activitystatusreload.sheduleId,
                              );
          this.showChangeActivity = false;
    },
    async openChangeStatusmodal(studyId,visitNo, patientId, status, index,statusType,id,visitName,formStatus,formId,scheduleId){
      await this.closePopover(id)
      this.selectedForm=formId
      this.scheduleId=scheduleId
      this.statusType=statusType
        this.changeStatus = {
          studyId : studyId,
          visitNo : visitNo,
          subjectId : patientId,
          visitstatus : statusType =='Visit' ? status : formStatus
        }
      this.formIndex=index
      this.selectedVisitName=visitName
      this.visitIndex = index;
      this.showChangeSchedule = true;
    },
    popoverId(svisit,sIndex, pIndex, vIndex) {
      return `${svisit}-${sIndex}-${pIndex}-${vIndex}`;
    },
    async closeChangeScheduleModal() {
      this.showChangeSchedule = false;   
    },
    async changedStatus()
    {
      if(this.statusType=='Visit'){
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex);      
      }
      else{
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex);      
        await this.getFormsByVisit(this.changeStatus.subjectId,this.changeStatus.visitNo,this.selectedVisitName,this.visitIndex)
      }
    },
    loadPage: function (page) {
      this.currentoverduePage = page;
      this.pageoverdueindex = this.currentoverduePage;
      this.getoverduevisits();
    },
    loadPlanned: function (page) {
      this.currentplannedPage = page;
      this.pageplannedindex = this.currentplannedPage;
      this.getplannedvisits();
    },
    loadForm: function (page) {
      this.currentformPage = page;
      this.pageformindex = this.currentformPage;
      this.getForms();
    },
    loadrecentForm: function (page) {
      this.currentRecentformPage = page;
      this.recentpageformindex = this.currentRecentformPage;
      this.GetRecentFormData();
    },
  },
};
